factboxAppRoutes.$inject = ['$routeProvider', '$locationProvider', '$httpProvider'];
export default function factboxAppRoutes($routeProvider, $locationProvider, $httpProvider) {
	$locationProvider.html5Mode(false);
  $locationProvider.hashPrefix('');
	$routeProvider
		.when('/thankyou!', {
			redirectTo: function () {
				return '/?welcome=thankyou!';
			}
		})
		.when('/thankyou', {
			redirectTo: function () {
				return '/?welcome=thankyou';
			}
		})
		.when('/opt-out', {
			template: '<div style="text-align:center; width: 33%; margin: 16.5% auto 0;min-width:200px">' +
				'You\'re all set. We tracked you visiting this page on AdRoll and Perfect Audience. ' +
				'Return <a ng-click="openHome()" href>Home</a></div>',
		})
		.otherwise({
			redirectTo: function () {
				return (window.isFactWindow ? '/fact' : '/home');
			}
		});
	$httpProvider.interceptors.push('Unauthorized');
	$httpProvider.interceptors.push('ErrorFeedback');
	$httpProvider.interceptors.push('LoadingFeedback');
}



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.routes.js